import React, {Component} from 'react';
import {Calendar,Toast,Modal} from 'antd-mobile';
import {getShiftList} from '../../../service/homeService';
import "./style.less";
import moment from 'moment';
import connect from "react-redux/es/connect/connect";
const alert = Modal.alert;
const notShift = require('../../../common/image/notShift.png');
const t1 = require('../../../common/image/v2/t1.png');
const t2 = require('../../../common/image/v2/t2.png');
const t3 = require('../../../common/image/v2/t3.png');
const addimg = require('../../../common/image/v2/add.png');
const now = new Date();
@connect(
    state => ({userInfo: state.userInfo})
)
export default class SelectShift extends Component {
    originbodyScrollY = document.getElementsByTagName('body')[0].style.overflowY;
    constructor(props) {
        super(props);
        this.state = {
            isFlag:false,
            show:false,
            notDataLoading:0,
            config: {},
            startTime:now,
            shiftData:[],
            shiftCarResults:[],
            beforeFlag:false,
            afterFlag:true,
            shifList:[],
        };
    }
    componentDidMount() {
        if(this.props.location.state.dateType){
            this.getData(this.props.location.state.startDate);
            this.setState({startTime:moment(this.props.location.state.startDate)}) 
        }else{
            this.getData(moment(now).format('YYYY-MM-DD'));
        }
    }
    getData(startTime){
        Toast.loading('正在加载',0);
        let props = this.props.location.state;
        let shifList = []
        if(props.lineIds == undefined){
            props.lineIds = [{endStationId:props.endStationId,startStationId:props.startStationId,lineId:props.lineId,}]
        }
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                startCity:props.startCity,
                startPosition:props.startPosition,
                startAddress:props.startAddress,
                endPosition:props.endPosition,
                endCity:props.endCity,
                endAddress:props.endAddress,
                startDate:startTime,
                lineIds:props.lineIds,
            }
        };
        getShiftList(params).then((res)=>{
            if(res.data.code === '0000'){
                Toast.hide();
                this.setState({shiftData:res.data.data,shiftCarResults:res.data.data.shiftCarResults,notDataLoading:0});
                if (res.data.data.shiftCarResults == "") {
                    this.setState({notDataLoading:1});
                }
                res.data.data.shiftCarResults.map((n)=>{
                    if(n.remainingSeat > 0){
                        shifList.push(n)
                    }
                })
                this.setState({shifList:shifList})
            }else{
                Toast.info(res.data.msg,3);
                this.setState({notDataLoading:1});
            }
        })
    }

    renderBtn(config = {}) {
        return(
            <div className="timeDiv">
                <span className="before" style={this.state.beforeFlag ? {"opacity":1}:{"opacity":0.5}} onClick={()=>this.selDay('before')}>前一天</span>
                <div className="time"
                     onClick={() => {
                         document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
                         this.setState({
                             show: true,
                             config,
                         });
                     }}
                >
                    <i className="icon iconfont iconrili"/>
                    <span>{moment(this.state.startTime).format('MM月DD日')}</span>
                    <i className="icon iconfont iconrilixialaxuanze"/>
                </div>
                <span className="after" style={this.state.afterFlag ? {"opacity":1}:{"opacity":0.5}}  onClick={()=>this.selDay('after')}>后一天</span>
            </div>
        )
    }
    selDay(type){
        let nowDate = this.state.startTime;
        console.log(94,nowDate);
        if(type === 'before' && nowDate <= now){
            this.setState({beforeFlag:false});
            Toast.info("不能小于今天",2);
            return
        }
        if(type === 'after' && moment(nowDate).format('YYYY年MM月DD日') >= moment(new Date(+now + 5184000000)).format('YYYY年MM月DD日')){
            this.setState({afterFlag:false});
            Toast.info("不能大于预售期",2);
            return
        }
        if(type === 'before' && nowDate > now){
            this.setState({afterFlag:true});
            this.setState({
                startTime:moment(nowDate).subtract(1,"day")
            });
            this.getData(moment(nowDate).subtract(1,"day").format('YYYY-MM-DD'))
        }else
        if(type === 'after' && moment(nowDate).add(1,"day").format('YYYY年MM月DD日') <= moment(new Date(+now + 5184000000)).format('YYYY年MM月DD日')){
            this.setState({beforeFlag:true});
            this.setState({
                startTime:moment(nowDate).add(1,"day")
            });
            this.getData(moment(nowDate).add(1,"day").format('YYYY-MM-DD'))
        }
    }
    onConfirm = (startTime, endTime) => {
        if(startTime > now){
            this.setState({beforeFlag:true});
        }
        if(startTime <= now){
            this.setState({beforeFlag:false });
        }
        document.getElementsByTagName('body')[0].style.overflowY = this.originbodyScrollY;
        this.setState({
            show: false,
            startTime,
        });
        this.getData(moment(startTime).format('YYYY-MM-DD'))

    };

    onCancel = () => {
        document.getElementsByTagName('body')[0].style.overflowY = this.originbodyScrollY;
        this.setState({
            show: false,
        });
    };
    goSelSeat(res){
        let props = this.props.location.state;
        const params = {
            id:res.id,//班次id
            startCity:props.startCity,
            startStationId:res.startStationId,//出发站点id
            startPosition:props.startPosition,//出发经纬度
            startAddress:props.startAddress,//出发具体地址
            endCity:props.endCity,
            endStationId:res.endStationId,
            endPosition:props.endPosition,
            endAddress:props.endAddress,
            orderId:props.type ? null : props.id,
            specialPage:this.state.shiftData.specialPage,
            remainingSeat:res.remainingSeat,
            choiceSeat:res.choiceSeat
        };
        if(res.status === 0){
            if(res.startTimeStamp < new Date(+now + 7200000).getTime()){
                alert('是否确认预约？', <div>您选择的行程距离出发时间已经不足两小时， 购买后 <span>不支持取消和变更行程</span></div>, [
                    { text: '取消',style:{background:"#DADCDE",color:"#ACACAC",fontSize:"14px",height:"48px"}},
                    { text: '确认',style:{background:"#3679FE",color:"#FFFFFF",fontSize:"14px",height:"48px"}, onPress: () => {
                        if(props.type && props.type == 'address'){
                            if(this.state.shiftData.specialPage == 0){
                                this.props.history.push('/pay/selectSeat',params);
                            }else{
                                if(res.choiceSeat == 0){
                                    console.log(res,'1');
                                    this.props.history.push('/pay/selectSeat',params);
                                }else if(res.choiceSeat == 1){
                                    console.log(res,'2');
                                    this.props.history.push('/pay/SelectSeatSpecial',params);
                                }
                            }
                            
                        }else{
                            this.props.history.push('/pay/orderChange',params);
                        }
                    } },
                ]);
            }else{
                if(props.type && props.type == 'address'){
                    if(this.state.shiftData.specialPage == 0){
                        this.props.history.push('/pay/selectSeat',params);
                    }else{
                        if(res.choiceSeat == 0){
                            console.log(res,'1');
                            this.props.history.push('/pay/selectSeat',params);
                        }else if(res.choiceSeat == 1){
                            console.log(res,'2');
                            this.props.history.push('/pay/SelectSeatSpecial',params);
                        }
                    }
                }else{
                    this.props.history.push('/pay/orderChange',params);
                }
            }
        }

    }
    noCar(){
        let flag = false;
        for(let i = 0; i < this.state.shiftCarResults.length;i++){
            if(this.state.shiftCarResults[i].status == 0 && this.state.shiftCarResults[i].remainingSeat !== 0){
               return
            }
            flag = true;
        }
        if(flag){
            return (
                <div className="noCarBox">
                    <p>温馨提示</p>
                    <div className="text">今天已经没有可预约车辆</div>
                    <div>
                        <button className="left" ><i className="icon iconfont iconlianxijiache" /><a href={`tel:${this.state.shiftData.contactPhone}`}>联系加车</a></button>
                        <button className="right" onClick={()=>{
                            localStorage.setItem("tabType",'1');
                            this.props.history.go(-2)
                        }}><i className="icon iconfont iconshenqingbaoche" />申请包车</button>
                    </div>
                </div>
            )
        }
    }
    judge(){    
        let props = this.props.location.state;
        if(this.state.notDataLoading == 0){
            if(this.state.shiftData.specialPage == 0){
                return (
                    this.state.shiftCarResults.map((res,i)=>(
                       <div className="itemBoxW"> 
                        <div className="itemBox">
                            { res.isBusiness == 1 ? <img className="img1" src={t1}></img> : res.seatNum>7?<img className="img1" src={t3}></img>:<img className="img1" src={t2}></img>}
                            { res.isAddWork &&res.isAddWork ==1? <img className="addimg" src={addimg}></img>:''}
                            <div className="item"
                                key={i}
                                style={res.status === 0 ? null : {
                                    backgroundColor: '#f9f9f9',
                                    opacity: 0.3
                                }}
                                onClick={() => this.goSelSeat(res)}
                            >
                                
                                <div className="left">
                                    <div className="startTime">{res.startTime}<span>出发</span></div>
                                    <div className="pickUpTime">{res.pickUpTime} 开始接人</div>
                                </div>
                                <div className="carType"><p>{res.seatNum + "座"}</p><p className="type">车型</p></div>
                                <div className="right">
                                    <div className="picDiv">
                                        {
                                            res.status == 1 ? (<span>已出发<p className="type">{'￥' + res.price} 起</p></span>) :
                                                (res.remainingSeat == 0 ?
                                                    <span>已满员<p className="type">{'￥' + res.price} 起</p></span> :
                                                    <span>余座：
                                                        <p className="num">{res.remainingSeat}</p>
                                                        <p className="type">{'￥' + res.price} 起</p>
                                                    </span>
                                                )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        { res.isAddWork &&res.isAddWork == 1? <div className="mrr">*此行程为加班车,价格略有调整,如有疑问可咨询<a href="tel:4001389889" onClick={(e)=>{
                                    e.stopPropagation()
                                }}>400-138-9889</a></div>:''}
                        
                        </div>
                    ))
                )
            }
            if(this.state.shiftData.specialPage == 1){
                return(
                    this.state.shiftCarResults.map((res,i)=>(
                        <div
                            className="itemlist"
                            key={i}
                            style={res.status === 0 ? null : {
                                backgroundColor: '#f9f9f9',
                                opacity: 0.3
                            }}
                            onClick={() => this.goSelSeat(res)}
                        >
                            <div className="top">
                                {res.seatNum + "座商务车"}
                            </div>
                            <div className="bottom">
                                <div className="left">
                                    <div>
                                        <i className="icon iconfont icontime" />
                                        可预约时间：<span className="time"> {res.pickUpTime+ "～" + res.startTime} </span>
                                    </div>
                                    <div>
                                        <i className="icon iconfont iconchufa" />
                                        <span className="startCity">{this.state.shiftData.startCity}</span> <span className="address">{props.startAddress}</span>
                                    </div>
                                    <div style={{paddingBottom:0}}>
                                        <i className="icon iconfont icondaoda" />
                                        <span  className="endCity">{this.state.shiftData.endCity}</span> <span  className="address">{props.endAddress}</span>
                                    </div>
                                </div>
                                <div className="right">
                                    {
                                        res.status == 1 ? (<span><p className="type"><span className='prefix'>￥</span>{res.price}<span className='suffix'>起</span></p><p className='typetxt'>已出发</p></span>) :
                                            (res.remainingSeat == 0 ?
                                                <span><p className="type"><span className='prefix'>￥</span>{res.price}<span className='suffix'>起</span></p><p className='typetxt'>已满员</p></span> :
                                                <span><p className="type"><span className='prefix'>￥</span>{res.price} <span className='suffix'>起</span></p><p className="num">可约人数:<span>{res.remainingSeat}</span></p>
                                                    </span>)
                                    }
                                </div>
                            </div>
                            <div className="botel">
                                <div className="license">{res.carNum}</div>
                                <div className="phone" ><a href={`tel:${res.driverPhone}`} onClick={(e)=>{
                                    e.stopPropagation()
                                }}><i className="icon iconfont icondingdanxiangqingdianhua" /></a></div>
                            </div>
                        </div>
                    ))
                )
            }
        }else{
            return (
                <div className="noMore" style={{marginTop:"18%"}}>
                    <img src={notShift} />
                    <p>暂无数据</p>
                </div>
            )
        }
    }
    render(){
        return(
            <div className="selectShift">
                {
                    this.state.shiftData.specialPage == 0 ? (
                        <div className="topBar">
                            <div className="goBack">
                                <i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />
                            </div>
                            <div className="city">
                               <div className='startLeft'> {this.state.shiftData.startCity}</div> <div>——</div> <div className='endRiht'>{this.state.shiftData.endCity}</div> 
                            </div>

                            {this.renderBtn({ type: 'one' })}
                            <div className="hint"><i className="icon iconfont iconshuomingtishi"/>应国家法律法规，乘坐网约车必须携带有效证件。</div>

                        </div>
                    ):(
                        <div className="topBar">
                            <div className="goBack">
                                <i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />
                                <span className="title">可约车辆</span>
                            </div>
                            {this.renderBtn({ type: 'one' })}
                            <div className="hint"><i className="icon iconfont iconshuomingtishi"/>应国家法律法规，乘坐网约车必须携带有效证件。</div>
                        </div>
                    )
                }


                <div className="warp">
                    <div className="content">
                        {this.noCar()}
                        {this.judge()}
                    </div>
                </div>

                <Calendar
                    {...this.state.config}
                    visible={this.state.show}
                    onCancel={this.onCancel}
                    onConfirm={this.onConfirm}
                    defaultDate={now}
                    minDate={now}
                    // maxDate={new Date(+now + 5184000000)}
                    title={'选择日期'}
                    defaultTimeValue={now}
                />
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/SelectShift/index.js